module.exports = __webpack_public_path__ + "static/media/Compress-PDF.2407aab4.png";